import { element } from "prop-types";
import { createContext, useContext, useRef, useState } from "react";

export const NewFormFieldContext = createContext();
export const useNewFormFieldContext = () => useContext(NewFormFieldContext);

export const NewFormFieldProvider = ({ children }) => {
  const formRef = useRef(null);
  const [selectedFieldType, setSelectedFieldType] = useState(null);

  return (
    <NewFormFieldContext.Provider
      value={{
        formRef,
        selectedFieldType,
        setSelectedFieldType,
      }}
    >
      {children}
    </NewFormFieldContext.Provider>
  );
};

NewFormFieldProvider.propTypes = {
  children: element.isRequired,
};
